import React from 'react';

/**
 * WizardStep - Container for individual wizard steps
 * 
 * Provides consistent styling and layout for each step in the onboarding wizard
 * Simplified to avoid redundant step indicators
 */
export function WizardStep({ step, title, description, children }) {
	return (
		<div className="wizard-step max-w-2xl mx-auto">
			{/* Step header - simplified without redundant number */}
			<div className="mb-8">
				<h2 className="text-2xl font-bold text-foreground mb-3">{title}</h2>
				{description && (
					<p className="text-lg text-muted-foreground leading-relaxed">{description}</p>
				)}
			</div>

			{/* Step content with better spacing */}
			<div className="wizard-step-content">
				{children}
			</div>
		</div>
	);
} 